import { FormConfigBase } from './abstract/form-config-base.class';
import { CheckboxInterface } from '../interfaces/checkbox.interface';
import { BtnTooltipModel } from './btn.tooltip.model';

export class CheckboxModel extends FormConfigBase {
  label: string;
  checked: boolean;
  error: string;
  tooltip?: BtnTooltipModel;

  constructor( obj: CheckboxInterface  ) {
    super( obj );

    this.label = obj && obj.label ? obj.label : '';
    this.checked = obj && !!obj.checked;
    this.error = obj && obj.error ? obj.error : '';
    this.tooltip = new BtnTooltipModel( obj && obj.tooltip ? obj.tooltip : null);

  }

}
